import soy from "refractor/soy";
export default soy;